module.exports = __webpack_public_path__ + "static/img/logo-wm.19eca9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/logo-wm.png
// module id = lwyY
// module chunks = 63